/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Daterangepicker_Selectdate3Inputs */

const id_components_daterangepicker_selectdate3 = /** @type {(inputs: Components_Daterangepicker_Selectdate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pilih tanggal`)
};

const ms_components_daterangepicker_selectdate3 = /** @type {(inputs: Components_Daterangepicker_Selectdate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pilih tarikh`)
};

const da_components_daterangepicker_selectdate3 = /** @type {(inputs: Components_Daterangepicker_Selectdate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vælg dato`)
};

const de_components_daterangepicker_selectdate3 = /** @type {(inputs: Components_Daterangepicker_Selectdate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datum wählen`)
};

const en_us2_components_daterangepicker_selectdate3 = /** @type {(inputs: Components_Daterangepicker_Selectdate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select date`)
};

const es_es2_components_daterangepicker_selectdate3 = /** @type {(inputs: Components_Daterangepicker_Selectdate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecciona una fecha`)
};

const es_mx2_components_daterangepicker_selectdate3 = /** @type {(inputs: Components_Daterangepicker_Selectdate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccionar fecha`)
};

const fil_components_daterangepicker_selectdate3 = /** @type {(inputs: Components_Daterangepicker_Selectdate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pumili ng petsa`)
};

const fr_components_daterangepicker_selectdate3 = /** @type {(inputs: Components_Daterangepicker_Selectdate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélectionner une date`)
};

const it_components_daterangepicker_selectdate3 = /** @type {(inputs: Components_Daterangepicker_Selectdate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona data`)
};

const hu_components_daterangepicker_selectdate3 = /** @type {(inputs: Components_Daterangepicker_Selectdate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dátum kiválasztása`)
};

const nl_components_daterangepicker_selectdate3 = /** @type {(inputs: Components_Daterangepicker_Selectdate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecteer datum`)
};

const no_components_daterangepicker_selectdate3 = /** @type {(inputs: Components_Daterangepicker_Selectdate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Velg dato`)
};

const pl_components_daterangepicker_selectdate3 = /** @type {(inputs: Components_Daterangepicker_Selectdate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wybierz datę`)
};

const pt_br2_components_daterangepicker_selectdate3 = /** @type {(inputs: Components_Daterangepicker_Selectdate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecionar data`)
};

const pt_components_daterangepicker_selectdate3 = /** @type {(inputs: Components_Daterangepicker_Selectdate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecionar data`)
};

const ro_components_daterangepicker_selectdate3 = /** @type {(inputs: Components_Daterangepicker_Selectdate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selectează data`)
};

const fi_components_daterangepicker_selectdate3 = /** @type {(inputs: Components_Daterangepicker_Selectdate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valitse päivämäärä`)
};

const sv_components_daterangepicker_selectdate3 = /** @type {(inputs: Components_Daterangepicker_Selectdate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Välj datum`)
};

const vi_components_daterangepicker_selectdate3 = /** @type {(inputs: Components_Daterangepicker_Selectdate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn ngày`)
};

const tr_components_daterangepicker_selectdate3 = /** @type {(inputs: Components_Daterangepicker_Selectdate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarih seç`)
};

const cs_components_daterangepicker_selectdate3 = /** @type {(inputs: Components_Daterangepicker_Selectdate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vybrat datum`)
};

const bg_components_daterangepicker_selectdate3 = /** @type {(inputs: Components_Daterangepicker_Selectdate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изберете дата`)
};

const ru_components_daterangepicker_selectdate3 = /** @type {(inputs: Components_Daterangepicker_Selectdate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выбрать дату`)
};

const uk_components_daterangepicker_selectdate3 = /** @type {(inputs: Components_Daterangepicker_Selectdate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вибрати дату`)
};

const ar_components_daterangepicker_selectdate3 = /** @type {(inputs: Components_Daterangepicker_Selectdate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اختر التاريخ`)
};

const hi_components_daterangepicker_selectdate3 = /** @type {(inputs: Components_Daterangepicker_Selectdate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`तारीख़ चुनें`)
};

const th_components_daterangepicker_selectdate3 = /** @type {(inputs: Components_Daterangepicker_Selectdate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เลือกวันที่`)
};

const ja_components_daterangepicker_selectdate3 = /** @type {(inputs: Components_Daterangepicker_Selectdate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日付を選択`)
};

const zh_cn2_components_daterangepicker_selectdate3 = /** @type {(inputs: Components_Daterangepicker_Selectdate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择日期`)
};

const zh_hant1_components_daterangepicker_selectdate3 = /** @type {(inputs: Components_Daterangepicker_Selectdate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選擇日期`)
};

const ko_components_daterangepicker_selectdate3 = /** @type {(inputs: Components_Daterangepicker_Selectdate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`날짜 선택`)
};

/**
* | output |
* | --- |
* | "Select date" |
*
* @param {Components_Daterangepicker_Selectdate3Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_daterangepicker_selectdate3 = /** @type {((inputs?: Components_Daterangepicker_Selectdate3Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Daterangepicker_Selectdate3Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_daterangepicker_selectdate3(inputs)
	if (locale === "ms") return ms_components_daterangepicker_selectdate3(inputs)
	if (locale === "da") return da_components_daterangepicker_selectdate3(inputs)
	if (locale === "de") return de_components_daterangepicker_selectdate3(inputs)
	if (locale === "en-US") return en_us2_components_daterangepicker_selectdate3(inputs)
	if (locale === "es-ES") return es_es2_components_daterangepicker_selectdate3(inputs)
	if (locale === "es-MX") return es_mx2_components_daterangepicker_selectdate3(inputs)
	if (locale === "fil") return fil_components_daterangepicker_selectdate3(inputs)
	if (locale === "fr") return fr_components_daterangepicker_selectdate3(inputs)
	if (locale === "it") return it_components_daterangepicker_selectdate3(inputs)
	if (locale === "hu") return hu_components_daterangepicker_selectdate3(inputs)
	if (locale === "nl") return nl_components_daterangepicker_selectdate3(inputs)
	if (locale === "no") return no_components_daterangepicker_selectdate3(inputs)
	if (locale === "pl") return pl_components_daterangepicker_selectdate3(inputs)
	if (locale === "pt-BR") return pt_br2_components_daterangepicker_selectdate3(inputs)
	if (locale === "pt") return pt_components_daterangepicker_selectdate3(inputs)
	if (locale === "ro") return ro_components_daterangepicker_selectdate3(inputs)
	if (locale === "fi") return fi_components_daterangepicker_selectdate3(inputs)
	if (locale === "sv") return sv_components_daterangepicker_selectdate3(inputs)
	if (locale === "vi") return vi_components_daterangepicker_selectdate3(inputs)
	if (locale === "tr") return tr_components_daterangepicker_selectdate3(inputs)
	if (locale === "cs") return cs_components_daterangepicker_selectdate3(inputs)
	if (locale === "bg") return bg_components_daterangepicker_selectdate3(inputs)
	if (locale === "ru") return ru_components_daterangepicker_selectdate3(inputs)
	if (locale === "uk") return uk_components_daterangepicker_selectdate3(inputs)
	if (locale === "ar") return ar_components_daterangepicker_selectdate3(inputs)
	if (locale === "hi") return hi_components_daterangepicker_selectdate3(inputs)
	if (locale === "th") return th_components_daterangepicker_selectdate3(inputs)
	if (locale === "ja") return ja_components_daterangepicker_selectdate3(inputs)
	if (locale === "zh-CN") return zh_cn2_components_daterangepicker_selectdate3(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_daterangepicker_selectdate3(inputs)
	return ko_components_daterangepicker_selectdate3(inputs)
});
export { components_daterangepicker_selectdate3 as "components.dateRangePicker.selectDate" }